export const GLOBALS = {
  NAME: 'PROD',
  PRODUCTION: true,
  API: {
    BASE_URL: 'https://balloons-api.digitalemenschen.app',
  },
  APP_URL: 'https://balloons.digitalemenschen.app',
  CODE_PREFIX: 'dbr-',
  CODE_NUMBER_LENGTH: 6,
  QRCODE_URL: 'https://dbr.digitalemenschen.app/race/',
  TRANSLATION_PATH: './assets/i18n/',
  BALLOONS_UPDATE_LINK: '/balloons/update-positions',
  BALLOONS_TEMPLATE_GREY: true
};
